import { Dialog, DialogProps, Slide } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { PropsWithChildren } from 'react';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: 'fit-content',
    overflow: 'hidden',
    '@media(max-width: 500px)': {
      height: 'auto',
      width: '100%',
      margin: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  container: {
    '@media(max-width: 500px)': {
      alignItems: 'flex-end',
      '& > div': {
        maxWidth: '100% !important',
      },
    },
  },
}));

const Transition = (props: any) => {
  return <Slide direction='up' {...props} />;
};

const MobileModal = ({children, ...props}: PropsWithChildren<DialogProps>) => {
  const classes = useStyles();

  return (
    <Dialog
      {...props}
      disableBackdropClick={false}
      TransitionComponent={Transition}
      classes={{ paper: classes.paper, container: classes.container }}
    >
      {children}
    </Dialog>
  );
};

export default MobileModal;
